import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthShell } from '../components/AuthShell';
import { SetPasswordForm } from '../components/SetPasswordForm';

const activateSearchSchema = z.object({
  token: z.string().optional(),
  // Post-activation destination — used by the candidate flow so that
  // after setting a password, the user lands straight on
  // `/candidate/aptitude` instead of bouncing to `/login`. Validated
  // inside SetPasswordForm before any redirect.
  next: z.string().optional(),
});

export const Route = createFileRoute('/activate')({
  validateSearch: activateSearchSchema,
  component: ActivatePage,
});

function ActivatePage() {
  const { token, next } = Route.useSearch();

  if (!token || token.trim().length === 0) {
    return (
      <AuthShell
        tagline="Activation link missing."
        taglineSub="Ask your administrator for a new one."
      >
        <h1 className="font-display text-3xl font-bold tracking-tight">
          Activation link is invalid
        </h1>
        <p className="mt-3 text-sm text-[color:var(--color-text-muted)]">
          The link you followed is missing the security token. Ask your administrator
          to send a new activation email.
        </p>
        <div className="mt-8">
          <Link
            to="/login"
            className="text-sm text-[color:var(--color-text-muted)] underline"
          >
            Back to sign in
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      tagline="Welcome to Babul Ilm."
      taglineSub="Set your password to activate your account."
    >
      <SetPasswordForm token={token} mode="activate" {...(next ? { next } : {})} />
    </AuthShell>
  );
}
